/**
 * Schema.org Utility Functions
 * Date parsing helpers from SchemaMarkup.tsx
 */

/**
 * Convert "July 2024" format to ISO date
 * From SchemaMarkup.tsx lines 579-596
 */
export function parseReviewDate(dateStr: string): string {
  const months: Record<string, string> = {
    January: '01',
    February: '02',
    March: '03',
    April: '04',
    May: '05',
    June: '06',
    July: '07',
    August: '08',
    September: '09',
    October: '10',
    November: '11',
    December: '12',
  };
  const [month, year] = dateStr.split(' ');
  return `${year}-${months[month] || '01'}-15`;
}

/**
 * Convert "June 2025" to ISO date for events
 * From SchemaMarkup.tsx lines 1179-1198
 */
export function parseEventDate(dateStr: string): string {
  const months: Record<string, string> = {
    January: '01',
    February: '02',
    March: '03',
    April: '04',
    May: '05',
    June: '06',
    July: '07',
    August: '08',
    September: '09',
    October: '10',
    November: '11',
    December: '12',
  };
  const parts = dateStr.split(' ');
  const month = months[parts[0]] || '01';
  const year = parts[1] || '2025';
  return `${year}-${month}-01`;
}
